import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 客户当前账户状态
 */
class CustomerState extends UltMeta {
    UNREGISTERED = new Meta(0, "未实名");
    PERSONAUTH = new Meta(1, "完成个人认证");
    SYSENTERPRISEAUTH = new Meta(2, "完成个人认证，系统内企业认证");
    ENTERPRISEAUTH = new Meta(3, "完成个人认证，系统内企业认证，契约锁企业认证");
    CORPORATEAUTH = new Meta(4, "完成个人认证，系统内企业认证，契约锁企业认证，企业授权");
}
export const CUSTOMER_PHONE_STATE = new CustomerState();

class ChangeMobileState extends UltMeta {
    NO = new Meta(0, "当前状态不能换绑");
    YES = new Meta(1, "当前状态可以换绑");
    PROCESSING = new Meta(2, "换绑中");
}
export const CHANGE_MOBILE_STATE = new ChangeMobileState();
